export const companyStatusValues = ['active', 'suspended'] as const;
export type CompanyStatus = (typeof companyStatusValues)[number];

export const deploymentModeValues = ['offline_only', 'hybrid', 'saas'] as const;
export type DeploymentMode = (typeof deploymentModeValues)[number];

export const planCodeValues = ['BASIC', 'PRO', 'ENTERPRISE'] as const;
export type PlanCode = (typeof planCodeValues)[number];

export const billingStatusValues = ['trial', 'active', 'past_due', 'canceled'] as const;
export type BillingStatus = (typeof billingStatusValues)[number];

export interface CompanyDto {
  id: string; // UUID
  name: string;
  timezone?: string;
  receiverDirectoryScopeId?: string | null;
  status: CompanyStatus;
  deploymentMode: DeploymentMode;
  planCode: PlanCode;
  billingStatus: BillingStatus;
  trialExpiresAt: string | null; // ISO timestamp
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}

export interface CreateCompanyRequest {
  name: string;
  planCode: PlanCode;
  timezone?: string;
}

export interface CreateCompanyResponse {
  company: CompanyDto;
  membershipId: string;
}

export interface UpdateCompanyRequest {
  companyId: string;
  name?: string;
  timezone?: string | null;
}

export type SetupCompanyDeploymentMode = Extract<DeploymentMode, 'offline_only' | 'hybrid'>;

export interface SetupCompanyDeploymentModeRequest {
  companyId: string;
  deploymentMode: SetupCompanyDeploymentMode;
}

export interface SetupCompanyDeploymentModeResponse {
  company: CompanyDto;
  mutation: {
    changed: boolean;
    source: 'desktopSetup';
  };
}

export interface UpdateCompanySystemRequest {
  companyId: string;
  name?: string;
  timezone?: string | null;
  receiverDirectoryScopeId?: string | null;
  status?: CompanyStatus;
  deploymentMode?: DeploymentMode;
  planCode?: PlanCode;
  billingStatus?: BillingStatus;
  trialExpiresAt?: string | null;
}

export interface UpdateCompanyResponse {
  company: CompanyDto;
}

export interface GetCompanyRequest {
  companyId: string;
}

export interface GetCompanyResponse {
  company: CompanyDto;
}

export interface ListCompaniesRequest {
  status?: CompanyStatus;
  deploymentMode?: DeploymentMode;
  planCode?: PlanCode;
  billingStatus?: BillingStatus;
  page?: number;
  pageSize?: number;
}

export interface ListCompaniesResponse {
  items: CompanyDto[];
  page: number;
  pageSize: number;
  total: number;
}
